import apiClient from './apiClient';

/**
 * 获取访问系统统计数据
 * @param {number} days 查询最近天数 (3, 7, 30)
 * @returns {Promise<Object>} 统计数据
 */
const getDailyReport = async (days = 7) => {
  console.log('AccessLogService: Calling API with days parameter:', days);
  try {
    const params = { days };
    console.log('AccessLogService: Request params:', params);
    
    const response = await apiClient.get('/api/report/access_daily', params);
    console.log('AccessLogService: Raw API response:', response);
    
    // 根据后端API响应格式，数据在 response.data.data 中
    // 后端返回格式: {code: 200, message: 'success', data: {...actual_data...}}
    if (response && response.data && response.data.data) {
      console.log('AccessLogService: Processed response data:', response.data.data);
      return response.data;  // 返回整个response.data对象，其中包含code, message, data字段
    } else if (response && response.data) {
      // 如果response.data就是实际数据（兼容不同格式）
      console.log('AccessLogService: Direct response data:', response.data);
      return { code: 200, message: 'success', data: response.data };
    } else {
      console.warn('AccessLogService: Response format unexpected:', response);
      return { code: 200, data: { total_pv: 0, total_uv: 0, hourly_heat: [], user_pv_ranking: [] }, message: 'success' };
    }
  } catch (error) {
    console.error('AccessLogService: Error fetching daily report:', error);
    if (error.response && error.response.data) {
      console.error('AccessLogService: Error response data:', error.response.data);
      throw { ...error, message: error.response.data.message || '获取访问数据失败' };
    }
    throw error;
  }
};

/**
 * 获取访问日志明细分页列表
 * @param {Object} params 查询参数 { page, page_size, search }
 * @returns {Promise<Object>} 日志列表数据
 */
const getAccessLogsList = async (params = {}) => {
  console.log('AccessLogService v2: Calling getAccessLogsList directly with params object:', params);
  try {
    const response = await apiClient.get('/api/report/access_daily/list', params);
    console.log('AccessLogService: Raw getAccessLogsList response:', response);
    
    if (response && response.data && response.data.data) {
      return response.data;
    } else if (response && response.data) {
      return { code: 200, message: 'success', data: response.data };
    } else {
      console.warn('AccessLogService: Response format unexpected:', response);
      return { code: 200, data: { items: [], total: 0, page: 1, page_size: 20 }, message: 'success' };
    }
  } catch (error) {
    console.error('AccessLogService: Error fetching access logs list:', error);
    if (error.response && error.response.data) {
      throw { ...error, message: error.response.data.message || '获取访问日志明细失败' };
    }
    throw error;
  }
};

export default {
  getDailyReport,
  getAccessLogsList,
};
